import * as API from 'common/constant/routes'
import { getJson, postJson, putFile } from 'helper/http'
import toSnakeCase from '@hellofiremind/map-keys-case/to-snake-case'

export const getDatasets = (sort, direction, limit, start, pagination) => getJson(API.GET_DATASETS, {}, toSnakeCase({ direction, limit, pagination, sort, start }))
export const addNewDataset = (datasetObject) => postJson(API.ADD_DATASET, {}, { ...datasetObject })
export const editDataset = (datasetObject) => postJson(API.EDIT_DATASET, {}, { ...datasetObject })
export const uploadFile = (url, file) => putFile(url, file, file.type)
export const searchDatasets = (searchTerm, sort, direction, limit, start) => getJson(API.SEARCH_DATASETS, {}, toSnakeCase({ direction, limit, searchTerm, sort, start }))
export const downloadDatasets = (columns) => postJson(API.DOWNLOAD_DATASET, {}, { columns })
